import React from 'react';
import { Flex, Text } from 'rebass';
import Icon from '../Icon/Icon';
import { SidebarItem, SidebarSection as SidebarSectionType } from './navConfig';
import SidebarLink from './SidebarLink';
import { useTheme } from 'emotion-theming';
import { Theme } from '@/theme';

type Props = {
  section: SidebarSectionType;
  mode: string;
  collapsed: boolean;
};

const SidebarSection = ({ section, mode, collapsed }: Props): JSX.Element => {
  const theme = useTheme<Theme>();

  return (
    <Flex
      flexDirection="column"
      mb={1}
      sx={{
        userSelect: 'none',
        overflow: 'hidden',
      }}
    >
      {/* Section header — not a link */}
      <Flex
        py={2}
        px={3}
        sx={{
          gap: 2,
          alignItems: 'center',
          whiteSpace: 'nowrap',
          justifyContent: collapsed ? 'center' : undefined,
        }}
      >
        {section.icon && (
          <Icon
            icon={section.icon}
            size={16}
            style={{ flexShrink: 0, color: theme.colors.base.gray[500] }}
          />
        )}
        {!collapsed && (
          <Text
            sx={{
              color: theme.colors.base.gray[500],
              fontSize: 1,
              fontWeight: 'heading',
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
            }}
          >
            {section.label}
          </Text>
        )}
      </Flex>

      {/* Child links — no icons, indented */}
      {section.items.map((item: SidebarItem, i: number) => (
        <SidebarLink
          key={i}
          exact={!item.href}
          to={`/${mode}${item.href}`}
          collapsed={collapsed}
        >
          {!collapsed && item.text}
        </SidebarLink>
      ))}
    </Flex>
  );
};

export default SidebarSection;
